import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { useBillingContext } from "./BillingContext";

const localeRoot = "settings.billing.manage_billing.plan_details";

export const IncludedFeatures = () => {
  const { currentPlan } = useBillingContext();

  if (!currentPlan) return null;

  return (
    <div>
      <Typography.LabelSm weight="medium">
        {t(`${localeRoot}.included`)}
      </Typography.LabelSm>
      <Typography.BodySm>
        <Icon
          type="circle-checked"
          size={16}
          useWithFillCurrentColor
          useWithStrokeCurrentColor
          className="text-dark mr-2"
        />
        {t(`${localeRoot}.included_features.${currentPlan.tier}`)}
      </Typography.BodySm>
    </div>
  );
};
